import { useRef, useState } from 'react';
import { Link as RouterLink, Navigate, useLocation } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Tooltip } from '@mui/material';
// components
import MenuPopover from '../MenuPopover';
// mocks_
import { dotCase, sentenceCase, capitalCase } from 'change-case';
import React from 'react';
import moment from 'moment';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
    linkTo: '#',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
    linkTo: '#',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const location = useLocation();
  const [open, setOpen] = useState(null);
  const [account, setAccount] = useState({first_name: '', last_name: '', email:'', user_type:'',sub_end_date:''});

React.useMemo(()=> {
  setAccount(JSON.parse(sessionStorage.getItem('user_details')))
}, [sessionStorage.getItem('user_details')])

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    // <Navigate to="/login" state={{ location }} replace />
    setOpen(null);
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user_details');

  }

  const sub_end_date= moment(account?.sub_end_date || account.subscription_end_date).format('Do MMMM YYYY')

  return (
    account?.email && account?.first_name && account?.last_name && account?.user_type ?   <>
    <Tooltip title="Profile">
     <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          bgcolor : 'white',
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              // bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
         boxShadow: 'rgb(163, 163, 163) 6px 11px 9px 1px'
        }}
      >
        <Avatar >{account?.first_name ? capitalCase(account?.first_name.split('')[0]): ''}</Avatar>
      </IconButton> 
      </Tooltip>
      
      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5, fontSize:'16px !important' }}>
          <Typography variant="subtitle2" noWrap fontWeight={600}>
          {account?.first_name?capitalCase(account?.first_name):null}&nbsp;{account?.last_name?capitalCase(account?.last_name):null}
          </Typography>
          <Typography>({capitalCase(account?.user_type)})</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {account.email}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} /> 
        <MenuItem>
        <Typography variant="body2" noWrap={false}   sx={{
      wordWrap: 'break-word',   // Break the word if it exceeds the line
      whiteSpace: 'pre-wrap',    // Allow text to wrap and show new lines
      overflow: 'hidden',       // Hide any overflow text
    }}>Your subscription will expire on {sub_end_date} </Typography>
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} /> 
        <MenuItem component={RouterLink} to='/dashboard/profile'>
        <Typography variant="subtitle2" noWrap fontWeight={600}> Profile  </Typography>
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem component={RouterLink} to='/dashboard/changePassword'>
        <Typography variant="subtitle2" noWrap fontWeight={600}>{account.user_type === 'admin' ? 'Change Password' : 'Change M-Pin'}</Typography>
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem component={RouterLink} to='/login' onClick={handleLogout} sx={{ m: 1 }}>
        <Typography variant="subtitle2" noWrap fontWeight={600}> Logout  </Typography>
        </MenuItem>
      </MenuPopover>
    </>   :null
  );
}
